import {
  Modal as MUIModal,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import { ModalCloseIcon, QuestionMark } from "../../@lib/icons";
import { useLanguageTranslator } from "../useLanguageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function ConfirmationDeleteModal({
  isOpen,
  item,
  handleClose,
  onClickHandler,
}: any) {
  const { translator } = useLanguageTranslator();
  return (
    <div>
      <MUIModal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
          >
            <Button
              onClick={handleClose}
              sx={{ padding: "0px", minWidth: "auto" }}
            >
              <ModalCloseIcon />
            </Button>
          </Stack>
          <Stack
            direction="column"
            sx={{ padding: "10px 60px" }}
            alignItems="center"
          >
            <QuestionMark />
            <Typography
              id="modal-modal-title"
              mt={2}
              mb={3}
              sx={{ fontSize: "16px" }}
            >
              {translator(
                "Are you sure you want to delete this following item?"
              )}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="center" gap={1} mt={2}>
            <Button
              sx={{
                backgroundColor: "#FF6D6D",
                "&:hover": {
                  backgroundColor: "#D9534F",
                },
                color: "white",
                padding: "7px 50px",
              }}
              onClick={() => onClickHandler(item)}
            >
              {translator("generic.DELETE")}
            </Button>
            <Button
              onClick={handleClose}
              sx={{
                backgroundColor: "#989C9F",
                "&:hover": {
                  backgroundColor: "#6D757D",
                },
                color: "white",
                padding: "7px 50px",
              }}
            >
              {translator("Cancel")}
            </Button>
          </Stack>
        </Box>
      </MUIModal>
    </div>
  );
}

export { ConfirmationDeleteModal };
